export const RoutePathEnum = Object.freeze({
	SUPERVISOR_QR_CHECK_IN: '/supervisor/availableqrci',
	SUPERVISOR_QR_CHECKOUT: '/supervisor/availableqrco'
});
